/**
 * Checks if the value is null or undefined
 * @param value 
 * 
 * @returns {boolean} true/false
 */
export const nullOrUndefined = (value:any) => {
  return (value === null || value === undefined)
}